import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import blockUI from 'react-block-ui/reduxMiddleware';
import api from './common/middleware/api';
import rootReducer from './reducers';
import Config from 'Config';

const middlewares = [
	thunk,
	api,
	blockUI
];

if (Config.environment !== 'production') {
	const { logger } = require('redux-logger');

	middlewares.push(logger);
}

const composeEnhancers = (Config.environment !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const configureStore = preloadedState =>
	createStore(
		rootReducer,
		preloadedState,
		composeEnhancers(applyMiddleware(...middlewares))
	);

export default configureStore;